import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'rsuite/dist/rsuite.min.css';
import '../App.css';
import { CBSDStatuses, DecommissionStatuses } from '../constants/GlobalConstants';
import '../pages/Home.css';
import { exists, getTechnology } from '../services/helper';

interface AssetSummaryProps {
  searchedView: any;
  summary: any;
  refreshAssets: any;
  searchFilters: any;
}

const CBSDAssetsNav: React.FC<AssetSummaryProps> = ({ searchedView, summary, refreshAssets, searchFilters }) => {
  const navigate = useNavigate();

  const [viewType, setViewType] = useState(CBSDStatuses.FIELD_TECH.key);
  // const [userFilter, setUserFilter] = useState('All');
  // const [installerSearchString, setInstallerSearchString] = useState('');
  // const [installerUsers, setInstallerUsers] = useState<any>([]);
  // const [cpiSearchString, setCpiSearchString] = useState('');
  // const [cpiAdmins, setCpiAdmins] = useState<any>([]);
  // const [error, setError] = useState({
  //   message: '',
  //   alert: false,
  // });

  useEffect(() => {
    refreshAssets(viewType);
  }, [viewType]);

  // useEffect(() => {
  //   getUsers(UserRoles.INSTALLER);
  //   getUsers(UserRoles.CPI);
  // }, []);

  // useEffect(() => {
  //   if (exists(installerSearchString)) {
  //     searchUser(installerSearchString, UserRoles.INSTALLER);
  //   } else {
  //     getUsers(UserRoles.INSTALLER);
  //   }
  // }, [installerSearchString]);

  {
    /** Called on dropdown CPI search */
  }
  // useEffect(() => {
  //   if (exists(cpiSearchString)) {
  //     searchUser(cpiSearchString, UserRoles.CPI);
  //   } else {
  //     getUsers(UserRoles.CPI);
  //   }
  // }, [cpiSearchString]);

  const isFieldTech = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses.FIELD_TECH.key : viewType === CBSDStatuses.FIELD_TECH.key;
  };

  const isCloud = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses.CLOUD.key : viewType === CBSDStatuses.CLOUD.key;
  };

  const isSAS = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses.SAS.key : viewType === CBSDStatuses.SAS.key;
  };

  const isAFC = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses.AFC_SUBMITTED.key : viewType === CBSDStatuses.AFC_SUBMITTED.key;
  };

  const isOpenWifi = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses['OPEN_WI-FI'].key : viewType === CBSDStatuses['OPEN_WI-FI'].key;
  };

  const isRMA = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses.RMA_REQUESTED.key : viewType === CBSDStatuses.RMA_REQUESTED.key;
  };

  const isDecommission = () => {
    return exists(searchedView)
      ? [
          DecommissionStatuses.PHYSICALLY_DECOMMISSIONED.key,
          DecommissionStatuses.DECOMMISSION_REQUESTED.key,
          DecommissionStatuses.DECOMMISSIONED.key,
        ].includes(searchedView)
      : [
          DecommissionStatuses.PHYSICALLY_DECOMMISSIONED.key,
          DecommissionStatuses.DECOMMISSION_REQUESTED.key,
          DecommissionStatuses.DECOMMISSIONED.key,
        ].includes(viewType);
  };

  const isPreloaded = () => {
    return exists(searchedView) ? searchedView === CBSDStatuses.PRELOADED.key : viewType === CBSDStatuses.PRELOADED.key;
  };

  return (
    <div className="d-flex h-btn wrap-flex">
      <div className="d-flex h-btn wrap-flex bg-white">
        <div
          onClick={() => {
            setViewType(CBSDStatuses.PRELOADED.key);
          }}
          className={'row-wise border-left-only h-btn ' + (isPreloaded() ? 'selected-view' : 'unselected-view')}>
          <span>{CBSDStatuses.PRELOADED.displayText}</span>
          <div className={'count-bubble ' + (isPreloaded() && 'info-icon-blue')}>
            <span>{summary.preloadedCount}</span>
          </div>
        </div>

        {/* <span className="vertical"></span> */}
        <div
          onClick={() => {
            setViewType(CBSDStatuses.FIELD_TECH.key);
          }}
          className={'row-wise border-noradius h-btn ' + (isFieldTech() ? 'selected-view' : 'unselected-view')}>
          <span>{CBSDStatuses.FIELD_TECH.displayText}</span>
          <div className={'count-bubble ' + (isFieldTech() && 'info-icon-blue')}>
            <span>{summary.fieldCount}</span>
          </div>
        </div>

        {/* <span className="vertical"></span> */}
        <div
          onClick={() => {
            setViewType(CBSDStatuses.CLOUD.key);
          }}
          className={'row-wise border-noradius h-btn ' + (isCloud() ? 'selected-view' : 'unselected-view')}>
          <span>{CBSDStatuses.CLOUD.displayText}</span>
          <div className={'count-bubble ' + (isCloud() && 'info-icon-blue')}>
            <span>{summary.cloudCount}</span>
          </div>
        </div>

        {/* <span className="vertical"></span> */}
        {['wifi_6e', 'tarana'].includes(getTechnology()) && (
          <div
            onClick={() => {
              setViewType(CBSDStatuses.AFC_SUBMITTED.key);
            }}
            className={'row-wise border-noradius h-btn ' + (isAFC() ? 'selected-view' : 'unselected-view')}>
            <span>{CBSDStatuses.AFC_SUBMITTED.displayText}</span>
            <div className={'count-bubble ' + (isAFC() && 'info-icon-blue')}>
              <span>{summary.afcCount}</span>
            </div>
          </div>
        )}

        {['cbrs_5g', 'tarana'].includes(getTechnology()) && (
          <div
            onClick={() => {
              setViewType(CBSDStatuses.SAS.key);
            }}
            className={'row-wise border-noradius h-btn ' + (isSAS() ? 'selected-view' : 'unselected-view')}>
            <span>{CBSDStatuses.SAS.displayText}</span>
            <div className={'count-bubble ' + (isSAS() && 'info-icon-blue')}>
              <span>{summary.sasCount}</span>
            </div>
          </div>
        )}

        {/* <span className="vertical"></span> */}
        <div
          onClick={() => {
            setViewType(CBSDStatuses.RMA_REQUESTED.key);
          }}
          className={'row-wise border-noradius h-btn ' + (isRMA() ? 'selected-view' : 'unselected-view')}>
          <span>{CBSDStatuses.RMA_REQUESTED.displayText}</span>
          <div className={'count-bubble ' + (isRMA() && 'info-icon-blue')}>
            <span>{summary.rmaCount}</span>
          </div>
        </div>
        {/* <span className="vertical"></span> */}
        <div
          onClick={() => {
            setViewType(DecommissionStatuses.PHYSICALLY_DECOMMISSIONED.key);
          }}
          className={'row-wise border-right h-btn ' + (isDecommission() ? 'selected-view' : 'unselected-view')}>
          <span>{CBSDStatuses.DECOMMISSION.displayText}</span>
          <div className={'count-bubble ' + (isDecommission() && 'info-icon-blue')}>
            <span>{summary.decommissionCount > 0 ? summary.decommissionCount : 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CBSDAssetsNav;
